import React from 'react';

function Metar(props) {
  return(
    <div className="metar">
      {props.data} 
    </div>
  );
}

export default Metar;


/** WEBPACK FOOTER **
 ** ./src/Metar/Metar.js
 **/